import { CancelTokenSource } from 'axios'
import AnonymousAgent from '../api/AnonymousAgent'
import {
  UnpaidWageSearchSubmitDetailsRequest,
  UnpaidWageSearchSubmitRequest,
} from '../models/UnpaidWages'

class UnpaidWageService {
  submit = async (
    request: UnpaidWageSearchSubmitRequest,
    source?: CancelTokenSource
  ) => {
    return AnonymousAgent.UnpaidWages.submit(request, source)
  }

  possibleMatch = async (
    request: UnpaidWageSearchSubmitDetailsRequest,
    source?: CancelTokenSource
  ) => {
    return AnonymousAgent.UnpaidWages.possibleMatch(request, source)
  }
}

export default new UnpaidWageService()
